import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { StyledPillComponent } from "./pill-component.scss";
const PillComponent = ({ label, backgroundColor, borderColor, borderThickness, borderRadius, textColor, fontSize, padding, margin, hoverOpacity })=>{
    return /*#__PURE__*/ _jsx(StyledPillComponent, {
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderThickness: borderThickness,
        borderRadius: borderRadius,
        textColor: textColor,
        fontSize: fontSize,
        padding: padding,
        margin: margin,
        hoverOpacity: hoverOpacity,
        children: label
    });
};
export default PillComponent;
